import React, {useEffect} from 'react';
import TelegramLinkSection from '../../TelegramLinkSection';
import {StepProps} from './types';

/**
 * Шаг «Уведомления» (слот 13): привязка Telegram. Раздел переиспользуется целиком
 * (`TelegramLinkSection`, CTHS-52) — он сам держит состояния «не привязан / ожидание / привязан»
 * и пишет в `/api/telegram/*`. Мастеру остаётся отметить, что шаг показан.
 */
const StepChannels: React.FC<StepProps> = ({onChange}) => {
    useEffect(() => {
        onChange({visited: true});
        // Отметка одноразовая: пересоздание onChange родителем не должно перезаписывать ответ.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="space-y-3" data-testid="onboarding-step-channels">
            <p className="text-sm text-gray-600 dark:text-gray-300">
                Привяжите Telegram, если хотите получать напоминания о носке, образ дня и итоги
                разбора гардероба. Шаг не обязателен — привязку можно сделать позже в профиле.
            </p>
            <TelegramLinkSection/>
        </div>
    );
};

export default StepChannels;
